import React from "react";
//assets
import { MessageBoxContainer, MessageBoxContent, MessageBoxIconDiv } from "./styles";
//interfaces
import { IMessageBox } from "./interface";

const MessageBox: React.FC<IMessageBox> = (props) => {
  const {
    icon,
    boxTitle,
    message,
    color,
    borderColor,
    backgroundColor
  } = props;

  return (
    <MessageBoxContainer color={color} backgroundColor={backgroundColor} borderColor={borderColor}>
      <MessageBoxIconDiv>
        {icon}
      </MessageBoxIconDiv>
      <MessageBoxContent color={color}>
        <p><strong>{boxTitle}</strong> {message}</p>
      </MessageBoxContent>
    </MessageBoxContainer>
  );
};

export default MessageBox;